import React, {useContext, useEffect, useRef, useState} from "react";
import logo from '../assets/images/psb-logo.png';
import {useLocation, useNavigate} from "react-router-dom";
import {isSessionCustomer} from "./Utils";
import {Grid} from "@mui/material";
import Toast from "./Toast";
import Button from "@mui/material/Button";
import MDButton from "../../components/MDButton";
import {logout} from "./api/PortalCustomerApi";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import CustomerLoginForm from "../../CustomerLoginForm";
import NotificationItem from "../Items/NotificationItem";
import {CompanyContext} from "../../lib/CompanyProvider";
import {MenuContext} from "../../lib/MenuProvider";
import {UserContext} from "../../lib/UserProvider";
import CartFinal from "../cx/cart/CartFinal";
import {setAppCookie} from "./appCookie";
import {CONSTANTS} from "./constants";
import MenuIcon from '@mui/icons-material/Menu';
import {CartContext} from "../../lib/CartProvider";
import Box from "@mui/material/Box";
import {useDragScroll} from "./ux/useDragScroll";

export default function CustomerHeader(props) {

  const navigate = useNavigate();
  const {containerRef, dragHandlers} = useDragScroll();

  const [userContext, setUserContext] = useContext(UserContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);
  const [company, setCompany] = useState();

  const [headerHtml, setHeaderHtml] = useState(null);
  const [sessionCustomer, setSessionCustomer] = useState(false);
  const [navItems, setNavItems] = useState();
  const [navBar, setNavBar] = useState([]);
  const [loginNag, setLoginNag] = useState(false);
  const [userAuthenticated, setUserAuthenticated] = useState(false);

  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyWebsite, setCompanyWebsite] = useState(null);

  useEffect(() => {
    setUserAuthenticated(userContext?.sessionUser?.guid?.length > 0);
  }, [userContext?.authenticated]);

  useEffect(() => {
    setLoginNag(userContext?.loginNag);
  }, [userContext?.loginNag]);

  useEffect(() => {
    setCompany(companyContext?.company);
    setCompanyLogo(companyContext?.company?.logoUrl);
    let website = companyContext?.company?.website;
    if (website) {
      website = website.replace('http://', '');
      website = website.replace('https://', '');
      setCompanyWebsite('https://' + website);
    }
  }, [companyContext?.company]);

  useEffect(() => {
    setNavItems(menuContext?.menuItems);
    populateNavItems(menuContext?.menuItems);
  }, [menuContext?.menuItems]);

  const [assignedWaivers, setAssignedWaivers] = useState([]);
  const [showLogin, setShowLogin] = useState(false);
  const [showCreateAccount, setShowCreateAccount] = useState(false);
  const [menuHandler, setMenuHandler] = useState(false);

  const location = useLocation();

  const clickHandler = (fnName) => {
    if ("logoutFn" === fnName) {
      logoutFn();
    } else if ("loginFn" === fnName) {
      setShowLogin(true);
    }
  }

  const populateNavItems = (navItems) => {
    let _items = [];
    for (let j in navItems) {
      _items.push(navItems[j]);
    }
    setNavBar(_items);
  }

  useEffect(() => {
    setSessionCustomer(isSessionCustomer(userContext?.sessionUser));
    setAssignedWaivers(userContext?.assignedWaivers);

    if (userContext?.refreshIdentity) {
      setShowLogin(false);
      setShowCreateAccount(false);
    }
  }, [userContext?.sessionUser]);

  useEffect(() => {
    if (userContext?.showLogin) {
      setUserContext({...userContext, showLogin: false});
      setShowLogin(true);
    }
  }, [userContext?.showLogin])

  const handleCreateAccount = () => {
    setShowCreateAccount(true);
  }

  useEffect(() => {
    if (menuHandler) {
      setMenuHandler(false);
      setMenuContext({...menuContext, refreshContext: true});
    }
  }, [menuHandler]);

  const handleLogin = () => {
    setShowLogin(false);
    setUserContext({...userContext, loginNag: false, refreshIdentity: true});
    setMenuHandler(true);
  }

  const image = {
    imageUrl: logo,
  }

  const logoutFn = async () => {
    let portalGuid = company?.guid;
    let resp = await logout();
    if (resp) {
      setAppCookie(CONSTANTS.PSB_SID, '');
      setAppCookie(CONSTANTS.PSB_UID, '');
      setUserContext({...userContext, refreshIdentity: true});
      setCompanyContext({...companyContext, refreshContext: true});
      setCartContext({...cartContext, reloadCart: true});
      setMenuHandler(true);
      window.location.reload();
    }
  }

  const MiniNavActions = () => {
    return (<PopupState variant="popover" popupId={'mini-nav-popup-menu'}>
      {(popupState) => (
        <>
          <h6 variant="contained" {...bindTrigger(popupState)}>
            <MenuIcon/>&nbsp;Menu
          </h6>
          <Menu {...bindMenu(popupState)}>
            {navBar?.map((item, idx) => {
              return (
                <span key={idx}>
                  <NotificationItem
                    onClick={(e) => {
                      e.preventDefault();
                      if (item.onClick) {
                        clickHandler(item.onClick)
                      } else {
                        navigate('/cx' + item.url)
                      }
                      popupState.close();
                    }} icon={<Icon></Icon>} title={item.name}/>
                </span>
              )
            })}
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const currentNavItem = (item) => {
    let match = ('/cx' + item.url) == location.pathname;
    if (item.itemId <= 1) {
      return false;
    }
    if (!match && item.url === '/' && location.pathname === '/') {
      return true;
    }
    return match;
  }

  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null, // viewport
        threshold: 0,
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollRight = () => {
    containerRef.current?.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Toast props={props}/>
      <Grid id={'psb-header'} container>

        <Grid container spacing={1} style={{
          position: 'sticky',
          top: '0',
          zIndex: '1000',
          background: '#fff',
          padding: '24px 0 0 0',
        }}>
          <div className="tab-container"
               ref={containerRef} {...dragHandlers}>
            <ul className={'tab-navigation'} style={{
              padding: '0 24px'
            }}>
              {!isVisible && <>
                <span style={{
                  position: 'absolute',
                  top: '8px',
                  right: '-2px',
                  background: '#fff',
                  zIndex: '99',
                  fontSize: '22px',
                  boxShadow: '-10px 0px 10px 1px #fff',
                  padding: '12px 4px 22px 2px',
                }} onClick={scrollRight}>&hellip;</span>
              </>}
              {companyContext?.subdomain &&
                <li className={'tab-item tab-item-home'}>
                  {companyLogo &&
                    <Button
                      draggable={false}
                      style={{
                        margin: '0',
                        padding: '0'
                      }}
                      href={companyWebsite || '#/cx'}
                      target={companyWebsite ? '_blank' : '_self'}
                      variant={"secondary"}>
                      <Box
                        sx={{
                          width: 'auto',
                          height: 36,
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          src={companyLogo}
                          alt="Logo"
                          style={{
                            width: 'auto',
                            maxHeight: '36px',
                            objectFit: 'cover',
                          }}
                        />
                      </Box>
                    </Button>}
                  {!companyLogo &&
                    <Button
                      draggable={false}
                      href={companyWebsite || '#/cx'}
                      target={companyWebsite ? '_blank' : '_self'}
                      variant={"secondary"}>
                  <span style={{
                    color: CONSTANTS.SITE_OPTIONS?.menu?.fontColor || 'inherit'
                  }}>
                    {company?.companyName}
                  </span>
                    </Button>
                  }
                </li>
              }

              {navBar && navBar.map((item, idx) => {
                return (
                  <li key={idx} className={'tab-item'}>
                    <Button
                      style={{
                        textTransform: 'inherit'
                      }}
                      href={'#/cx' + item.url}
                      draggable={false}
                      variant={"secondary"}
                      onClick={(e) => {
                        if (item.onClick) {
                          e.preventDefault();
                          clickHandler(item.onClick)
                        }
                      }}>
                  <span className={currentNavItem(item) ? 'underline' : ''} style={{
                    color: CONSTANTS.SITE_OPTIONS?.menu?.fontColor || 'inherit'
                  }}>
                    {item.name}
                  </span>
                    </Button>
                  </li>
                )
              })}
              <li className={'tab-item'} ref={elementRef}>
                <span style={{
                  width: '124px',
                  display: 'block',
                }}>
                &nbsp;</span>
              </li>

              <li className={'tab-item'}>
                <CartFinal props={props}/>
              </li>

            </ul>
          </div>

        </Grid>
      </Grid>

      {
        showLogin && <CustomerLoginForm
          show={showLogin}
          handleClose={() => {
            setShowLogin(false);
            if (loginNag && !userAuthenticated) {
              setShowLogin(true);
            }
          }}
          handleLogin={handleLogin}/>
      }

      {
        showCreateAccount && <CustomerLoginForm
          show={showCreateAccount}
          createAccount={true}
          handleClose={() => {
            setShowCreateAccount(false);
          }}
          handleLogin={handleLogin}/>
      }

    </>
  );

}